export default __webpack_public_path__ + "static/media/italy.f6481dde.webp";